import { render } from "./UpgradeButton.vue?vue&type=template&id=e60dde10&scoped=true"
import script from "./UpgradeButton.vue?vue&type=script&lang=js"
export * from "./UpgradeButton.vue?vue&type=script&lang=js"

import "./upgrade-button.scss?vue&type=style&index=0&id=e60dde10&scoped=true&lang=scss"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60dde10"]])

export default __exports__